import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import FinanceService from "Lib/API/Finance";
import MainTabs from "components/mainTabs/MainTabs";
import moment from "moment";
import ShareDocumentsModal from "pages/NewFinance/Documents/ShareDocumentsModal/index";
import ViewDocumentModal from "pages/NewFinance/Documents/ViewDocumentModal/index";
import React, { useEffect, useState } from "react";
import AccountInfo from "./AccountInfo";
import { Communication } from "./Communication/Communication";
import Documents from "./Documents";
import Events from "./Events";
import Notes from "./Notes";
import DeceasedTable from "./deceased/deceasedTable";
import FamilyTable from "./family/familyTable";
import Finance from "./finance/BillingTable";
import School from "./school";
import "./style.scss";
import EasyCarePage from "./EasyCare/index";
const AccountTabs = ({
  refresh,
  setRefresh,
  account,
  selected,
  setSelected,
  setShow,
  setFamilyMember,
  familyMember,
  viewDocumentHandler,
  downloadFileHandler,
  documentHandler,
  viewLetterHandler,
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const initialFilters = {
    sort: {},
    filter: {
      accountId: account?._id,
      hidden: true,
    },
  };
  let accountId = account?._id;
  const [filters, setFilters] = useState(initialFilters);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [financeTablePage, setFinanceTablePage] = useState(0);
  const [page, setPage] = useState(0);
  const [tabStatus, setTabStatus] = useState(false);
  const [sortData, setSortData] = useState(initialFilters);
  const [list /* setList */] = useState([]);

  const sortCharged = (e) => {
    setFilters((prev) => ({
      ...prev,
      sort: {
        [e]: prev.sort[e] === 1 ? -1 : 1,
      },
    }));
  };

  const onStatusChange = (status) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        charge_type: status === "COA" ? "credit_on_account" : undefined,
        charge_status:
          status === "Partial"
            ? "partially_paid"
            : status === "Paid"
            ? "closed"
            : undefined,
      },
      status:
        status !== "All" &&
        status !== "COA" &&
        status !== "Partial" &&
        status !== "Paid"
          ? status?.toLowerCase()
          : undefined,
    }));
  };

  const account_tabs = [
    {
      title: "Account info",
      value: "Account info",
      width: "130px",
      content: (
        <AccountInfo
          account={account}
          tabStatus={tabStatus}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      ),
    },
    {
      title: "Family",
      value: "Family",
      content: (
        <FamilyTable
          member={account}
          setRefresh={setRefresh}
          refresh={refresh}
          mainContactId={account?.main_contact?._id}
          setFamilyMember={setFamilyMember}
          familyMember={familyMember}
        />
      ),
    },
    {
      title: "Yahrzeits",
      value: "Yahrzeits",
      content: (
        <DeceasedTable
          member={account}
          setRefresh={setRefresh}
          refresh={refresh}
          accountId={account?._id}
        />
      ),
    },
    {
      title: "Education",
      value: "Education",
      content: <School member={account} />,
    },
    {
      title: "Events",
      value: "Events",
      content: <Events member={account} />,
    },
    {
      title: "Communications",
      value: "Communications",
      width: "150px",
      content: <Communication member={account} />,
    },
    {
      title: "Finances",
      value: "Finances",
      content: (
        <>
          <Finance
            account={account}
            memberId={account?.main_contact?._id}
            accountId={account?._id}
            page={financeTablePage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setFinanceTablePage}
            filters={filters}
            setFilters={setFilters}
            sortData={sortData}
            sortCharged={sortCharged}
            onStatusChange={onStatusChange}
            viewDocumentHandler={viewDocumentHandler}
            downloadFileHandler={downloadFileHandler}
            documentHandler={documentHandler}
            viewLetterHandler={viewLetterHandler}
            setRefresh={setRefresh}
          />
        </>
      ),
    },
    {
      title: "Documents",
      value: "Documents",
      width: "110px",
      content: <Documents accountId={account?._id} />,
    },
    {
      title: "Easycare",
      value: "Easycare",
      width: "110px",
      content: <EasyCarePage account={account} />,
    },
    {
      title: "Notes",
      value: "Notes",
      content: <Notes accountId={account?._id} />,
    },
  ];
  useEffect(() => {
    setShow(
      account_tabs.map((tab) => {
        if (tab.title === selected) return tab.content;
      })
    );
  }, [filters]);

  return (
    <MainTabs
      className="mb-8"
      tabs={account_tabs}
      activeTab={selected}
      onTabsChange={(tab) => {
        setSelected(tab.title);
        setShow(tab.content);
        setTabStatus(!tabStatus);
      }}
    />
  );
};
export default AccountTabs;
